export default __webpack_public_path__ + "static/media/Resources.175fe742.svg";